import { EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES, EUROPACE_PROCESS_PLATFORMS } from 'cpool-constants';
import { LoanRequest_EuropaceOffersSyncResponseErrorReceived } from 'cpool-events';
import { schemaId, schemaVorgangsnummer } from 'cpool-schemas';
import { z } from 'zod';

export const AcceptedOfferSynchronizationsTableDefinitionZod = z.object({
    loanRequestId: schemaId,
    platform: z.nativeEnum(EUROPACE_PROCESS_PLATFORMS),
    processId: schemaVorgangsnummer,
    status: z.nativeEnum(EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES),
    warning: LoanRequest_EuropaceOffersSyncResponseErrorReceived.prototype.getSchema().shape.reasons.element.nullable(),
});

export type AcceptedOfferSynchronizationsTableSchema = z.infer<typeof AcceptedOfferSynchronizationsTableDefinitionZod>;
